import playgroundApi from "../playgroundApi";
import {withDisplayErrorToUser} from "../error/error";
import {
  mySongsPageStore,
} from "../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {
  mySongsLibraryStore,
} from "../../pages/songs-router/modules/my-songs-library-store/mySongsLibrary.store";

class SongLesson {

  /**
   * dispatch user library clear, triggering reload
   * - should be run when adding or removing lesson from user library
   */
  protected dispatchUserLibraryClearAndReload(): void {
    mySongsLibraryStore.reset();
  }

  /**
   * dispatch update user library - lesson to change if shown as favorited
   */
  protected dispatchUserLibraryLessonFavoritedUpdate(lessonId: number, isFavorited:boolean=false): void {
    mySongsLibraryStore.setUserLibraryLessonFavorite({lessonId, isFavorited,});
  }

  /**
   * dispatch update song details - lesson in library
   *  to change if shown as in library or in library and favorited
   */
  protected dispatchSongDetailsLessonInLibraryUpdate(lessonId: number, isInLibrary:true, isFavorited:boolean): void;
  protected dispatchSongDetailsLessonInLibraryUpdate(lessonId: number, isInLibrary:false): void;
  protected dispatchSongDetailsLessonInLibraryUpdate(lessonId: number, isInLibrary:false, isFavorited:false): void;
  protected dispatchSongDetailsLessonInLibraryUpdate(lessonId: number, isInLibrary:boolean=false, isFavorited:boolean=false): void {
    mySongsPageStore.updateSongDetailsLessonUserLibraryAndFavorite(lessonId, isInLibrary, isFavorited);
  }

  protected async sendRequestAddLessonToLibrary(lessonId: number, isFavorited:boolean=false) {
    await withDisplayErrorToUser( async () => {
      void await playgroundApi.userLibraryAddLesson({lessonId, isFavorited});

      // update redux details lesson
      this.dispatchSongDetailsLessonInLibraryUpdate(lessonId, true, isFavorited);
      // clear user library, triggering reload of user library
      this.dispatchUserLibraryClearAndReload();
    });
  }

  protected async sendRequestUpdateLibraryLessonFavorite(lessonId: number, isFavorited:boolean=false) {
    return await withDisplayErrorToUser( async () => {
      const result = await playgroundApi.userLibraryAddLesson({lessonId, isFavorited});

      // update redux details lesson
      this.dispatchSongDetailsLessonInLibraryUpdate(lessonId, true, isFavorited);
      // update user library to show change of favorited
      this.dispatchUserLibraryLessonFavoritedUpdate(lessonId, isFavorited);

      return result;
    });
  }

  protected async sendRequestRemoveLessonFromUserLibrary(lessonId: number) {
    await withDisplayErrorToUser( async () => {
      void await playgroundApi.userLibraryRemoveLesson({lessonId,});

      // update redux details lesson
      this.dispatchSongDetailsLessonInLibraryUpdate(lessonId, false, false);
      // clear user library, triggering reload of user library
      this.dispatchUserLibraryClearAndReload();
    });
  }

  /**
   * add lesson to user library
   * @param lessonId
   */
  public async addToLibrary(lessonId: number) {
    await this.sendRequestAddLessonToLibrary(lessonId);
  }

  /**
   * add lesson to user library and mark as favorite
   * @param lessonId
   */
  public async addToLibraryAndFavorite(lessonId: number){
    await this.sendRequestAddLessonToLibrary(lessonId, true);
  }


  /**
   * update lesson in user library to be favorited
   * @param lessonId
   */
  public async favoriteExistingLibraryLesson(lessonId: number){
    return await this.sendRequestUpdateLibraryLessonFavorite(lessonId, true);
  }

  public async removeFavoriteExistingLibraryLesson(lessonId: number){
    return await this.sendRequestUpdateLibraryLessonFavorite(lessonId, false);
  }

  public async removeFromUserLibrary(lessonId: number){
    await this.sendRequestRemoveLessonFromUserLibrary(lessonId);
  }

}

export const songLesson = new SongLesson();
